import MicroModal from "micromodal";

export default function initModal() {
  MicroModal.init({
    // onShow: function () {
    // },
  });

  MicroModal.init({
    openTrigger: "data-open-modal",
    disableScroll: true,
    onShow: function () {
      document.body.classList.add("modal-open");
    },
    onClose: function () {
      document.body.classList.remove("modal-open");
    },
  });
}
